import React from "react";
import InstallAppLink from "./InstallAppLink";
import { InstallGuideTrigger } from "./InstallGuide";

/**
 * Slim donor-facing band that sits just above the marketing footer on org
 * storefronts, donation pages, P2P, raffle, and event pages. Encourages guests
 * to install the PWA so the org's pages live as an app icon on their phone.
 *
 * Hidden automatically when the page is already running as a standalone PWA.
 */
export default function DonorInstallStrip({ orgName = "", className = "" }) {
    return (
        <div className={`bg-primary/95 border-t border-accent/30 ${className}`.trim()} data-testid="donor-install-strip">
            <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-primary-foreground">
                <div className="space-y-1">
                    <p className="label-eyebrow text-[10px] text-accent">Take it with you</p>
                    <p className="text-sm sm:text-base font-heading">
                        {orgName ? `Save ${orgName} as an app on your phone` : "Save this page as an app on your phone"}
                    </p>
                    <p className="text-[11px] text-primary-foreground/70 max-w-md">
                        One-tap return to bids, donations, and tickets — no app store needed. Works offline at the venue.
                    </p>
                    <InstallGuideTrigger orgName={orgName} className="mt-1" />
                </div>
                <InstallAppLink orgName={orgName} variant="button" />
            </div>
        </div>
    );
}
